/**
 * But event name for Obs communication between emtter and listener
 */
export const BUS_EVENT_NAME = 'OBS::BIG_QUERY_MONICORE';

/**
 * Root key for Obs events
 */
export const OBS_EVENTS_ROOT_KEY = 'monicoreEvents';
